<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Edit Business Function
          <v-btn icon @click="$router.push('/businessfunction')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <!-- <v-col sm="2"
                ><label class="custom-form__label">Designation</label></v-col
              > -->
              <v-col sm="8">
                <v-select
                  v-model="domainName"
                  :item-text="(item) => item.domainName"
                  :items="domainList"
                  :item-value="(item) => item.id"
                  append-icon="expand_more"
                  :disabled="true"
                  filled
                  attach
                  label="Business Type/Domain"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="8">
                <v-text-field
                  v-model="valueStream"
                  label="Enter Value Stream"
                  :rules="nameRules"
                  filled
                />
              </v-col>
            </v-row>
            <v-row no-gutters v-for="(step, i) in computedSteps" :key="i">
              <v-col class="d-flex steps-col" sm="8">
                <v-text-field
                  v-model="step.stepName"
                  label="Enter Step"
                  :rules="nameRules"
                  filled
                />
              </v-col>
              <v-col class="mt-3 pl-2">
                <v-btn v-if="i == computedSteps.length - 1" icon @click="addRow">
                  <v-icon color="#7F7F7F" size="18" class="font-weight-bold"
                    >add</v-icon
                  >
                </v-btn>
                <v-btn v-if="i || (!i && computedSteps.length>1)" icon @click="deleteRow(step,i)">
                  <v-icon color="#7F7F7F" size="16" class="font-weight-bold"
                    >remove</v-icon
                  >
                </v-btn>
              </v-col>
            </v-row>
            <font color="red" class="v-virtual-table">{{ text }}</font>
            <v-row>
              <v-col class="text-center mt-8">
                <v-btn
                  :disabled="!valid || buttonCheck()"
                  class="primary_btn small"
                  depressed
                  @click="toFindDuplicate"
                  >Save</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { storeActions } from '@/store/actions.constants';
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    valid: false,
    stepName: null,
    isDuplicate: false,
    text: '',
    valueStream: null,
    businessObj: {},
    steps: [],
    domainTotalList: [],
    domainData: [],
    domainName: '',
    domainId: null,
    vsmId: null,
    search: '',
    page: 1,
    itemsPerPage: 10,
    loading: false,
    sortDesc: [],
    options: {},
    nameRules: [
      (v) => !!v || 'Value Stream is Required',
      (v)=>v.length>0 && /^[^\s]/.test(v)|| 'Initial character should not be a space',
      (v) => !!(v && v.toString().split('  ').length <= 1) || 'Only one space is allowed in between 2 words',
      (v) => !!(v.trim().length>2&& v.trim().length<71) || "String length should be between 3 to 70",
      (v)=> /^[A-Za-z0-9_./#() &+-]{3,70}$/.test(v)|| "Only _./#()&+- special characters and numbers are allowed",
    ],
    stepRules: [
      (v) => !!v || 'Step is Required',
      (v)=>v.length>0 && /^[^\s]/.test(v)|| 'Initial character should not be a space',
      (v) => !!(v && v.toString().split('  ').length <= 1) || 'Only one space is allowed in between 2 words',
      (v) => !!(v.trim().length>2&& v.trim().length<71) || "String length should be between 3 to 70",
      (v)=> /^[A-Za-z0-9_./#() &+-]{3,70}$/.test(v)|| "Only _./#()&+- special characters and numbers are allowed",
    ],
  }),
  computed: {
    computedSteps(){
      return this.steps.filter(el=>el.isActive)
    },
    ...mapGetters({
      domains: 'businessFunction/getDomains',
      vsmList: 'businessFunction/getVsm',
    }),
    domainList() {
      return this.domains.data.map((domain) => ({
        id: domain.id,
        domainName: domain.name,
      }));
    },
  },
  async mounted() {
    let paramsId = this.$route.params.id;
    await this.getVsmById(paramsId);
    this.steps.push({ stepName: '' });
    let res = await this.getDomains({ page: 1, limit: 100 });
    this.domainTotalList = res.data;
  },
  methods: {
    ...mapActions({
      updateVsm: 'businessFunction/updateVsmById',
      getVsm: 'businessFunction/getVsmById',
      getDomainById: 'domains/getDomainById',
      getDomains: 'businessFunction/getDomain',
    }),
    async getDomainsList() {
      this.loading = true;
      const { sortBy } = this.options;
      await this.getDomains({
        page: this.page,
        limit: 10,
        search: this.search || '',
        // sort: sortBy[0],
        // desc: this.sortDesc[0] || 0,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res.data);
            let items = res.data.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
        });
    },
    getVsmById(paramsId) {
      const domainObj = {
        id: paramsId,
      };
      this.getVsm(domainObj)
        .then((res) => {
          this.domainName = res.data.domainId;
          this.valueStream = res.data.name;
          this.vsmId = res.data.vsmId;
          this.steps = res.data.steps;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          // Skip login until API and schema got finalise
          this.text = err.message;
          console.error(err);
        });
    },
     toFindDuplicate() {
    // let resultToReturn = false;
    // debugger
    // console.log('message',this.steps)
    var valueArr = this.steps.map(item =>  item.stepName.toLowerCase());
    var isDuplicate = valueArr.some((item, idx) => { 
             return valueArr.indexOf(item) != idx 
    });
    if (!isDuplicate) {
        this.updateBusinessFunctionById()
        }
        else{
          this.text = "Same step names are not allowed..";
        }
    },
    async updateBusinessFunctionById() {
      let res = this.vsmList;
      this.domainData = res.data;
      const businessObj = {
        vsmId: this.vsmId,
        domainId: this.domainName,
        name: this.valueStream,
        steps: this.steps,
      };
      this.updateVsm(businessObj).then((res) => {
        if (res.status === 200) {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: res.data.message,
            timeout: 1000,
            color: 'success',
          });
          this.$router.push('/businessfunction');
        } else {
          this.text = res.data.message;
        }
      });
    },
    buttonCheck() {
      if (
        this.domainName == null ||
        this.valueStream === null ||
        this.steps === []
      ) {
        return true;
      } else {
        return false;
      }
    },
    addRow() {
      this.steps.push({ stepName: '',isActive:1 });
    },
    deleteRow(step,index) {
      this.steps.filter(el=>el.isActive).map((el,i)=>{
        console.log(i,index)
        if(el.stepId==step.stepId && index==i){
          el.isActive=0;
        }
      })
      this.isDuplicate = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
